import { Box, Link as MuiLink } from '@mui/material';
import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { getStoreNavPath, scrollToGrowlersCatalog } from 'utils/growlersFlow';

const MobileQuickNav = () => {
  const { pathname } = useLocation();
  const storeNavPath = getStoreNavPath();

  const links = [
    { label: 'Assinatura', href: '/' },
    { label: 'Loja', href: storeNavPath },
    { label: 'Envelhecidas', href: '/envelhecidas' },
  ];

  const handleStoreClick = useCallback(
    (event: React.MouseEvent) => {
      if (!storeNavPath.includes('#')) {
        return;
      }
      if (pathname !== '/growlers') {
        return;
      }
      event.preventDefault();
      scrollToGrowlersCatalog();
    },
    [pathname, storeNavPath],
  );

  return (
    <Box
      component="nav"
      aria-label="Navegação rápida"
      sx={{
        display: { xs: 'flex', sm: 'none' },
        backgroundColor: '#000',
        color: '#fff',
        px: 1,
        py: 0.75,
        gap: 0.5,
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        '&::-webkit-scrollbar': { display: 'none' },
        scrollbarWidth: 'none',
      }}
    >
      {links.map(link => {
        const linkPath = link.href.split('#')[0];
        const isActive =
          linkPath === '/'
            ? pathname === '/'
            : pathname === linkPath || pathname.startsWith(`${linkPath}/`);
        const isStoreLink = link.label === 'Loja';

        return (
          <MuiLink
            key={link.label}
            href={link.href}
            underline="none"
            onClick={isStoreLink ? handleStoreClick : undefined}
            sx={{
              flex: 1,
              minWidth: 0,
              textAlign: 'center',
              color: '#fff',
              fontSize: 13,
              fontWeight: 700,
              lineHeight: 1.2,
              px: 1,
              py: 0.75,
              borderRadius: 1,
              whiteSpace: 'nowrap',
              bgcolor: isActive ? 'rgba(249, 97, 0, 0.25)' : 'transparent',
              borderBottom: isActive
                ? '2px solid #f96100'
                : '2px solid transparent',
            }}
          >
            {link.label}
          </MuiLink>
        );
      })}
    </Box>
  );
};

export default MobileQuickNav;
